// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"633761bb","455":"77f4795e","977":"aa1f48fc"}[chunkId] + ".chunk.js";
};